<template>
  <div class="device_modal">
    <div class="header">
      <h4 class="title">
        Snapshot Device Info
      </h4>
    </div>
    <div class="content">

      <div class="info-item">
        <fg-input
            type="text"
            v-model="device.fid"
            :readonly="true"
            :placeholder="translate('client_order.device_fid')"
            :label="translate('client_order.device_fid')"
        />
      </div>

      <div class="info-item">
        <fg-input
            type="text"
            v-model="device.user_name"
            :readonly="true"
            :placeholder="translate('client_order.user_name')"
            :label="translate('client_order.user_name')"
        />
      </div>

      <div class="info-item">
        <fg-input
            type="text"
            v-model="ts_created"
            :readonly="true"
            :placeholder="translate('client_order.date')"
            :label="translate('client_order.date')"
        />
      </div>

    </div>

    <div class="footer">
      <span
          class="btn btn-info btn-fill btn-wd marginButton"
          @click.prevent="return_device(false)"
      >
        {{ translate('client_order.return_to_warehouse') }}
      </span>

      <span
          class="btn btn-info btn-fill btn-wd marginButton"
          @click.prevent="return_device(true)"
      >
        {{ translate('client_order.return_defective_to_warehouse') }}
      </span>

      <span
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </span>
    </div>
  </div>

</template>
<script>

import { Terminal } from 'xterm'
import 'xterm/css/xterm.css'
import { FitAddon } from "xterm-addon-fit"

export default {
  name: "ShowDevice",
  props: ["device", "client_order_id"],
  data () {
    return {
    }
  },
  computed:{
    ts_created(){
      return this.get_date(this.device.ts)
    }
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    return_device(defect){
      let params = {
        fid: this.device.fid,
        client_order_id: this.client_order_id
      }
      defect ? params.defect = 1 : ""

      this.$http.v1.removeDevice(params, (response) => {
        if (response) {
          this.client_order_info = response.data
          this.global_notify('info', this.translate('client_order.device_sent_warehouse_success'))
          this.$emit('update', response.data)
        }else{
          this.global_notify('danger', this.translate('client_order.device_sent_warehouse_error'))
        }
      })
    }
  }
}

</script>

<style lang='scss' scoped>
  .device_modal{
    padding: 10px;
    .header{
      padding: 10px 0;
      .title{
        font-size: 22px;
        font-weight: 600;
        margin: 0;
        text-align: center;
      }
    }
    .content{
      padding: 10px 0;
    }
    .footer{
      display: flex;
      justify-content: center;
      align-items: center;
      .btn{
        margin: 0 5px;
        display: block;
      }
    }
  }

</style>
